import { render, staticRenderFns } from "./OliveOilsList.vue?vue&type=template&id=131ca7e0"
import script from "./OliveOilsList.vue?vue&type=script&lang=js"
export * from "./OliveOilsList.vue?vue&type=script&lang=js"
import style0 from "./OliveOilsList.vue?vue&type=style&index=0&id=131ca7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports